import MenuModule from './MenuModule';
import UserModule from './UserModule';

export default {
    MenuModule,
    UserModule
}
